import search from "@domains/utils/search";
import sort, { stringSort_depricated } from "@domains/utils/sort";
var EDISPresenter = /** @class */ (function () {
    function EDISPresenter(usecase, actions) {
        this.usecase = usecase;
        this.actions = actions;
    }
    EDISPresenter.prototype.getHoldingDetails = function (req) {
        var _this = this;
        this.actions.holdingDetails.hideError();
        this.actions.holdingDetails.startLoader();
        this.usecase.holdingDetails.execute({
            onSuccess: function (data) {
                if (data) {
                    _this.actions.holdingDetails.getHoldingData(data);
                }
                _this.actions.holdingDetails.stopLoader();
            },
            onError: function (error) {
                _this.actions.holdingDetails.setError({ isOpen: true, error: error });
                _this.actions.holdingDetails.stopLoader();
            },
        }, req);
    };
    EDISPresenter.prototype.getStatusDetails = function (req) {
        var _this = this;
        this.actions.holdingDetails.hideError();
        this.actions.holdingDetails.startLoader();
        this.usecase.statusDetails.execute({
            onSuccess: function (data) {
                if (data) {
                    _this.actions.holdingDetails.getHoldingData(data);
                }
                _this.actions.holdingDetails.stopLoader();
            },
            onError: function (error) {
                _this.actions.holdingDetails.setError({ isOpen: true, error: error });
                _this.actions.holdingDetails.stopLoader();
            },
        }, req);
    };
    EDISPresenter.prototype.getHistoryData = function (req) {
        var _this = this;
        this.actions.historyDetails.hideError();
        this.actions.historyDetails.startLoader();
        this.usecase.historyDetails.execute({
            onSuccess: function (data) {
                if (data) {
                    _this.actions.historyDetails.getHistoryData(data);
                }
                _this.actions.historyDetails.stopLoader();
            },
            onError: function (error) {
                _this.actions.historyDetails.setError({ isOpen: true, error: error });
                _this.actions.historyDetails.stopLoader();
            },
        }, req);
    };
    EDISPresenter.prototype.getReqIdHistoryData = function (req) {
        var _this = this;
        this.actions.reqIdHistory.hideError();
        this.actions.reqIdHistory.startLoader();
        this.usecase.reqIdHistory.execute({
            onSuccess: function (data) {
                if (data) {
                    _this.actions.reqIdHistory.getReqIdHistory(data);
                }
                _this.actions.reqIdHistory.stopLoader();
            },
            onError: function (error) {
                _this.actions.reqIdHistory.setError({ isOpen: true, error: error });
                _this.actions.reqIdHistory.stopLoader();
            },
        }, req);
    };
    EDISPresenter.prototype.applySearching = function (searchState, data) {
        var resultData = search(data, "symbolName", searchState);
        if (resultData && (resultData === null || resultData === void 0 ? void 0 : resultData.length) > 0) {
            return resultData;
        }
        else {
            return [];
        }
    };
    EDISPresenter.prototype.applySorting = function (sortRecord, data
    // sortData: Array<Sorts>
    ) {
        if (sortRecord.type && sortRecord.type === "string") {
            data = stringSort_depricated(data, sortRecord.key, sortRecord.order);
        }
        else {
            data = sort(data, sortRecord.key, sortRecord.order);
        }
        return data;
    };
    return EDISPresenter;
}());
export default EDISPresenter;
